/** Case Status (Order Status) filter options for the NYCBS External table. */
export const allCaseStatusOptions = [
  { label: "Open", value: "open" },
  { label: "Closed", value: "closed" },
];
